<template>
    <div class="app-body">
        
    </div>
</template>

<script>
    export default {
        components: {
            
        },
        data() {
            return {};
        },
        computed:{
            
        },
        mounted() {
            
        },
    };
</script>
<style lang="scss" scoped>

</style>
